import styled from 'styled-components';

export const StyledInviteUsers = styled.div`
	height: fit-content;
	margin-bottom: 50px;
`;
